import { actionType } from './';
import asyncActionCreator from '../../../utils/asyncActionCreator';
import WEB_API from '../../../API/api';

/** 打标签 - 任务列表 */
const getTaskListRequest = () => ({
    type: actionType.getTaskListRequest,
    payload: {}
});
const getTaskListSuccess = data => ({
    type: actionType.getTaskListSuccess,
    payload: { data }
});
const getTaskListFailure = error => ({
    type: actionType.getTaskListFailure,
    payload: { error }
});
export const getTaskList = (post_body, callback) => asyncActionCreator(
    WEB_API.QSELECTTNEW_TASK_PAGE_LIST,
    getTaskListRequest,
    getTaskListSuccess,
    getTaskListFailure,
    'POST',
    post_body,
    callback
);

/** 打标签 - 打标签人列表 */
const getSelectListRequest = () => ({
    type: actionType.getSelectListRequest,
    payload: {}
});
const getSelectListSuccess = data => ({
    type: actionType.getSelectListSuccess,
    payload: { data }
});
const getSelectListFailure = error => ({
    type: actionType.getSelectListFailure,
    payload: { error }
});
export const getSelectList = (post_body, callback) => asyncActionCreator(
    WEB_API.QSELECTTNEW_TASK_SELECT_LIST,
    getSelectListRequest,
    getSelectListSuccess,
    getSelectListFailure,
    'POST',
    post_body,
    callback
);
/** 打标签 - 打标签人列表 */
const getCheckListRequest = () => ({
    type: actionType.getCheckListRequest,
    payload: {}
});
const getCheckListSuccess = data => ({
    type: actionType.getCheckListSuccess,
    payload: { data }
});
const getCheckListFailure = error => ({
    type: actionType.getCheckListFailure,
    payload: { error }
});
export const getCheckList = (post_body, callback) => asyncActionCreator(
    WEB_API.QSELECTTNEW_TASK_CHECK_LIST,
    getCheckListRequest,
    getCheckListSuccess,
    getCheckListFailure,
    'POST',
    post_body,
    callback
);

/** 打标签 - 类型列表 */
const getFilterListRequest = () => ({
    type: actionType.getFilterListRequest,
    payload: {}
});
const getFilterListSuccess = data => ({
    type: actionType.getFilterListSuccess,
    payload: { data }
});
const getFilterListFailure = error => ({
    type: actionType.getFilterListFailure,
    payload: { error }
});
export const getFilterList = (post_body, callback) => asyncActionCreator(
    WEB_API.QSELECTTNEW_TASK_FILTER,
    getFilterListRequest,
    getFilterListSuccess,
    getFilterListFailure,
    'POST',
    post_body,
    callback
);
export const setStage = data => ({
    type: actionType.setStage,
    payload: { data }
});




// WEBPACK FOOTER //
// ./src/entry_app/question_manage/set_tag/action.js